import React, { useEffect, useRef } from "react";
import { Button, OutlinedInput } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import StopCircleIcon from '@mui/icons-material/StopCircle';

type SendButtonProps = {
  value: string;
  disabled?: boolean;
  isRunning: boolean;
  onChange: (value: string) => void;
  onCancel?: () => void;
  onClick: () => void;
}

const SendButton = (props: SendButtonProps) => {

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!props.disabled && props.value === "") {
      inputRef.current?.focus();
    }
  }, [props.disabled, props.value]);

  return <OutlinedInput
    inputRef={inputRef}
    placeholder="Type here ..."
    fullWidth
    autoComplete="off"
    name="ask"
    disabled={props.disabled}
    sx={{mt: 1, mb: 1, pl: 1, pr: 0}}
    endAdornment={props.isRunning && props.onCancel ?
      <Button
        size="small"
        sx={{ ml: "0.5rem" }}
        onClick={props.onCancel}
      >
        <StopCircleIcon />
      </Button> :
      <Button
        size="small"
        sx={{ ml: "0.5rem" }}
        disabled={props.disabled}
        onClick={() => {
          if (props.value === "") {
            return;
          }
          props.onClick();
        }}
      >
        <SendIcon />
      </Button>
    }
    value={props.value}
    onChange={(e) => props.onChange(e.currentTarget.value)}
    onKeyDown={(e) => {
      if (props.value === "" || e.key !== "Enter") {
        return;
      }
      props.onClick();
    }}
  />
}

export default SendButton;